export const MODAL_ID = "verify-company-modal";

export const VALIDATION = {
  required: {
    value: true,
    message: "FCA number is required",
  },
};
